<script setup lang="ts" generic="T">
import { Card, useIsMobile } from "@soft-db/ui";
import { warn } from "vue";

const props = defineProps<{
	fromLabel: string;
	fromItems: T[];

	toLabel: string;
	toItems: T[];
}>();

watchEffect(() => {
	if (props.fromItems.length !== props.toItems.length) {
		warn("prop `fromItems` and `toItems` length should match");
	}
});

const numberOfDiff = computed(() => Math.min(props.fromItems.length, props.toItems.length));

const isMobile = useIsMobile();
</script>

<template>
	<template v-if="isMobile">
		<Card class="flex flex-col gap-2 py-2">
			<h5 class="border-border border-b px-4">
				{{ fromLabel }}
			</h5>

			<div v-for="(_, idx) in numberOfDiff" :key="idx" class="px-4">
				<slot name="from" :item="fromItems[idx]" />
			</div>
		</Card>

		<Card class="flex flex-col gap-2 py-2">
			<h5 class="border-border border-b px-4">
				{{ toLabel }}
			</h5>

			<div v-for="(_, idx) in numberOfDiff" :key="idx" class="px-4">
				<slot name="to" :item="toItems[idx]" />
			</div>
		</Card>
	</template>

	<Card v-else class="grid grid-cols-[auto_auto] gap-2">
		<div class="border-border col-span-2 grid grid-cols-subgrid border-b px-4 py-2">
			<h5>{{ fromLabel }}</h5>
			<h5>{{ toLabel }}</h5>
		</div>

		<div
			v-for="(_, idx) in numberOfDiff"
			:key="idx"
			class="col-span-2 grid grid-cols-subgrid gap-2 px-4 pb-2"
		>
			<div>
				<slot name="from" :item="fromItems[idx]" />
			</div>
			<div>
				<slot name="to" :item="toItems[idx]" />
			</div>
		</div>
	</Card>
</template>
